//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

export function getMonitoringForms(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormDto[]> {
    let url_ = getBaseUrl() + "/api/MonitoringForms?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMonitoringForms,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMonitoringForms(_response);
    });
}

function processGetMonitoringForms(response: AxiosResponse): Promise<Types.MonitoringFormDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.MonitoringFormDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.MonitoringFormDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormDto[]>(null as any);
}

export function createMonitoringForm(dto: Types.CreateMonitoringFormDto, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormDto> {
    let url_ = getBaseUrl() + "/api/MonitoringForms";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateMonitoringForm,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateMonitoringForm(_response);
    });
}

function processCreateMonitoringForm(response: AxiosResponse): Promise<Types.MonitoringFormDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.MonitoringFormDto.fromJS(resultData200);
        return Promise.resolve<Types.MonitoringFormDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormDto>(null as any);
}

export function updateMonitoringForm(monitoringFormId: string, dto: Types.UpdateMonitoringFormDto, config?: AxiosRequestConfig | undefined): Promise<Types.MonitoringFormDto> {
    let url_ = getBaseUrl() + "/api/MonitoringForms/{monitoringFormId}";
    if (monitoringFormId === undefined || monitoringFormId === null)
      throw new Error("The parameter 'monitoringFormId' must be defined.");
    url_ = url_.replace("{monitoringFormId}", encodeURIComponent("" + monitoringFormId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateMonitoringForm,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateMonitoringForm(_response);
    });
}

function processUpdateMonitoringForm(response: AxiosResponse): Promise<Types.MonitoringFormDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.MonitoringFormDto.fromJS(resultData200);
        return Promise.resolve<Types.MonitoringFormDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MonitoringFormDto>(null as any);
}
let _requestConfigGetMonitoringForms: Partial<AxiosRequestConfig> | null;
export function getGetMonitoringFormsRequestConfig() {
  return _requestConfigGetMonitoringForms;
}
export function setGetMonitoringFormsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringForms = value;
}
export function patchGetMonitoringFormsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMonitoringForms = patch(_requestConfigGetMonitoringForms ?? {});
}

let _requestConfigCreateMonitoringForm: Partial<AxiosRequestConfig> | null;
export function getCreateMonitoringFormRequestConfig() {
  return _requestConfigCreateMonitoringForm;
}
export function setCreateMonitoringFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateMonitoringForm = value;
}
export function patchCreateMonitoringFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateMonitoringForm = patch(_requestConfigCreateMonitoringForm ?? {});
}

let _requestConfigUpdateMonitoringForm: Partial<AxiosRequestConfig> | null;
export function getUpdateMonitoringFormRequestConfig() {
  return _requestConfigUpdateMonitoringForm;
}
export function setUpdateMonitoringFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateMonitoringForm = value;
}
export function patchUpdateMonitoringFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateMonitoringForm = patch(_requestConfigUpdateMonitoringForm ?? {});
}